import { useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { fetchWbStickers } from "../../api/wb";
import {
  WB_STICKER_POPUP_FEATURES,
  WB_STICKER_SIZE_MM,
} from "../../config/wbStickerPrint";
import { createWbStickerPdfBlob } from "../../utils/wbStickerPdf";

export default function WbStickerPrintButton({ wbOrderId }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Запрашиваем растр с повышенным разрешением, чтобы термопринтеру было проще.
  const stickerFormat = "png";

  const handlePrint = async () => {
    setError("");
    setLoading(true);
    try {
      const numericOrderId = Number(wbOrderId);
      if (!Number.isFinite(numericOrderId)) {
        throw new Error("Некорректный номер заказа");
      }

      const stickersRes = await fetchWbStickers([numericOrderId], {
        type: stickerFormat,
        width: WB_STICKER_SIZE_MM.width,
        height: WB_STICKER_SIZE_MM.height,
      });
      const sticker = stickersRes?.stickers?.find(
        (s) => String(s.orderId) === String(numericOrderId),
      );

      if (!sticker?.file) {
        throw new Error("Стикер не найден в ответе WB");
      }

      const pdfBlob = await createWbStickerPdfBlob(sticker.file, WB_STICKER_SIZE_MM);
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open("", "_blank", WB_STICKER_POPUP_FEATURES);

      if (!printWindow) {
        URL.revokeObjectURL(pdfUrl);
        throw new Error("Разрешите всплывающее окно для печати стикера");
      }

      printWindow.document.write(`
        <html>
          <head>
            <title>Стикер WB</title>
            <style>
              html, body { margin: 0; padding: 0; height: 100%; }
              iframe { border: 0; width: 100%; height: 100%; }
            </style>
          </head>
          <body>
            <iframe src="${pdfUrl}" title="WB sticker PDF"></iframe>
            <script>
              const frame = document.querySelector('iframe');
              frame.onload = () => {
                try {
                  frame.contentWindow.focus();
                  frame.contentWindow.print();
                } catch (e) {
                  window.focus();
                }
              };
              window.onbeforeunload = () => { URL.revokeObjectURL('${pdfUrl}'); };
            </script>
          </body>
        </html>
      `);

      printWindow.document.close();
    } catch (err) {
      console.error("WB sticker print error", err);
      setError(err.message || "Не удалось получить стикер WB");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Stack spacing={0.75}>
        <Button
          variant="outlined"
          size="small"
          onClick={handlePrint}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Печать стикера (PDF)
        </Button>

        {error && (
          <Alert severity="error" variant="outlined" sx={{ py: 0, px: 1 }}>
            <Typography variant="caption" color="error.main">
              {error}
            </Typography>
          </Alert>
        )}
      </Stack>
    </Box>
  );
}
